import { render } from "./UserEmailForm.vue?vue&type=template&id=49cdf442"
import script from "./UserEmailForm.vue?vue&type=script&lang=ts"
export * from "./UserEmailForm.vue?vue&type=script&lang=ts"
script.render = render

export default script